const KoreanDramas = () => (
  <h1>Korean Dramas</h1>
);

export default KoreanDramas;
